module.exports = __webpack_public_path__ + "img/ongoing.09101ba4.svg";